var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_305_2446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3.375C0 1.51348 1.51348 0 3.375 0H11.8125V6.75C11.8125 7.6834 12.5666 8.4375 13.5 8.4375H20.25V16.0312H9.28125C7.41973 16.0312 5.90625 17.5447 5.90625 19.4062V27H3.375C1.51348 27 0 25.4865 0 23.625V3.375ZM20.25 6.75H13.5V0L20.25 6.75ZM9.28125 18.5625H10.9688C12.5982 18.5625 13.9219 19.8861 13.9219 21.5156C13.9219 23.1451 12.5982 24.4688 10.9688 24.4688H10.125V26.1562C10.125 26.6203 9.74531 27 9.28125 27C8.81719 27 8.4375 26.6203 8.4375 26.1562V19.4062C8.4375 18.9422 8.81719 18.5625 9.28125 18.5625ZM10.9688 22.7812C11.6701 22.7812 12.2344 22.217 12.2344 21.5156C12.2344 20.8143 11.6701 20.25 10.9688 20.25H10.125V22.7812H10.9688ZM16.0312 18.5625H17.7188C19.1162 18.5625 20.25 19.6963 20.25 21.0938V24.4688C20.25 25.8662 19.1162 27 17.7188 27H16.0312C15.5672 27 15.1875 26.6203 15.1875 26.1562V19.4062C15.1875 18.9422 15.5672 18.5625 16.0312 18.5625ZM17.7188 25.3125C18.1828 25.3125 18.5625 24.9328 18.5625 24.4688V21.0938C18.5625 20.6297 18.1828 20.25 17.7188 20.25H16.875V25.3125H17.7188ZM21.9375 19.4062C21.9375 18.9422 22.3172 18.5625 22.7812 18.5625H25.3125C25.7766 18.5625 26.1562 18.9422 26.1562 19.4062C26.1562 19.8703 25.7766 20.25 25.3125 20.25H23.625V21.9375H25.3125C25.7766 21.9375 26.1562 22.3172 26.1562 22.7812C26.1562 23.2453 25.7766 23.625 25.3125 23.625H23.625V26.1562C23.625 26.6203 23.2453 27 22.7812 27C22.3172 27 21.9375 26.6203 21.9375 26.1562V19.4062Z",
    fill: "url(#paint0_linear_305_2446)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_305_2446",
    x1: -2.87265,
    y1: 13.422,
    x2: 26.1774,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#164EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF6AE2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_305_2446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.e8374bd5b24dea08edf80bcd8f6d5fe9.svg";
export { ForwardRef as ReactComponent };